import { Component, OnInit, Input } from '@angular/core';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-grid-view-drv',
  templateUrl: './grid-view-drv.component.html',
  styleUrls: ['./grid-view-drv.component.scss'],
})
export class GridViewDrvComponent implements OnInit {
  @Input() commonData;
  @Input() search;
  @Input() displayCount: number = 30;
  displayData: Array<any>;
  currentPage: number = 1;
  data: any;
  constructor(
    private platform: Platform
  ) { }
  doInfinite(event) {
    setTimeout(() => {
      this.displayData.push(...this.commonData.slice(this.currentPage * this.displayCount, (this.currentPage + 1) * this.displayCount));
      this.currentPage++;
      event.target.complete();
      if (this.displayData.length == this.commonData.length) {
        event.target.disabled = true;
      }
    }, 500);
  }

  setDisplayData() {
    if (this.commonData.length > this.displayCount) {
      this.displayData = this.commonData.slice(0, this.displayCount);
    }
    else {
      this.displayData = this.commonData;
    }
  }
  ngOnInit() {
    this.setDisplayData();
  }
  ngOnChanges() {
    this.setDisplayData();
    // this.datas = this.commonData;
  }
}
